import { render, staticRenderFns } from "./i-fenshen-detail.vue?vue&type=template&id=283cea94"
import script from "./i-fenshen-detail.vue?vue&type=script&lang=js"
export * from "./i-fenshen-detail.vue?vue&type=script&lang=js"
import style0 from "./i-fenshen-detail.vue?vue&type=style&index=0&id=283cea94&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports